'use strict';

import type { UserDocument } from '../../Entities/User/UserDocument';
import { EntityCollection } from '../EntityCollection';

export class UserDocumentCollection extends EntityCollection<UserDocument> {}
